module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
 ** module id = 8
 ** module chunks = 0 1
 **/